import React from 'react';
import { Box, Typography } from '@mui/material';

function PremiumTag() {
    return (
        <Box
            sx={{
                backgroundColor: '#007bff',
                color: '#fff',
                padding: '2px 8px',
                borderRadius: '6px',
                fontWeight: 'bold',
                fontSize: '12px',
                display: 'inline-block',
            }}
        >
            PREMIUM
        </Box>
    );
}

export default PremiumTag;